import { Observable } from 'rxjs';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';

import { CartKeys } from '@config/keys/cart.keys';
import { DoodCartModel } from '@core/models/cart.model';

/**
 * Shop id used by CB visibility conditions on the cart page.
 * Shop pages bind `currentPage` from the route; the cart must bind it from the
 * active cart or per-shop blocks (e.g. suggestion cards) stay hidden.
 */
export function cartShopIdForPageVisibility(cart: DoodCartModel | null | undefined): string | null {
  const shopId = cart?.[CartKeys.Shop];
  return typeof shopId === 'string' && shopId.length > 0 ? shopId : null;
}

export function bindCurrentPageShopFromCart(
  cart$: Observable<DoodCartModel | null>,
  setCurrentPageShop: (id: string | null) => void,
  destroy$: Observable<unknown>,
): void {
  cart$
    .pipe(map(cartShopIdForPageVisibility), distinctUntilChanged(), takeUntil(destroy$))
    .subscribe(shopId => setCurrentPageShop(shopId));
}
